<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-head">
            <h1>{{ $t('modal.bottom+radio.store_etc_condition') }}</h1>
          </div>

          <div class="modal-delete">
            <i class="i-modal-delete" @click="emit('close')"></i>
          </div>

          <div class="modal-con check">
            <div class="modal-txt">
              <ul class="check-ul">
                <li class="form-li">
                  <div class="check-box">
                    <label class="checkbox">
                      <input type="checkbox" v-model="etcOption.ETC_ALL" @input="fnSelect" />
                      <span class="check-txt">
                        <!--                        전체-->
                        {{ $t('modal.delivery_fee_sort.all') }}
                      </span>
                    </label>
                  </div>
                </li>

                <li class="form-li">
                  <div class="check-box">
                    <label class="checkbox">
                      <input type="checkbox" v-model="etcOption.ETC_PACKABLE" />
                      <span class="check-txt">
                        <!--                        포장가능-->
                        {{ $t('common.packing') }}
                      </span>
                    </label>
                  </div>
                </li>

                <li class="form-li">
                  <div class="check-box">
                    <label class="checkbox">
                      <input type="checkbox" v-model="etcOption.ETC_RESERVABLE" />
                      <span class="check-txt">
                        <!--                        방문예약-->
                        {{ $t('cart.order_type.visit_reservation') }}
                      </span>
                    </label>
                  </div>
                </li>

                <li class="form-li">
                  <div class="check-box">
                    <label class="checkbox">
                      <input type="checkbox" v-model="etcOption.ETC_ONLINE_PAYMENT_AVAILABLE" />
                      <span class="check-txt">
                        <!--                        온라인 결제-->
                        {{ $t('common.online') }}
                      </span>
                    </label>
                  </div>
                </li>

                <li class="form-li">
                  <div class="check-box">
                    <label class="checkbox">
                      <input type="checkbox" v-model="etcOption.ETC_AUTOMATIC_WITHDRAWAL_AVAILABLE" />
                      <span class="check-txt">
                        <!--                        계좌이체-->
                        {{ $t('common.account_transfer') }}
                      </span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="modal-btn">
            <div class="btn-wrap">
              <!--                                <button class="btn bo">취소</button>-->
              <button class="btn yd-cta yd-cta--secondary" @click="fnClose">
                {{ $t('modal.delivery_fee_sort.close_btn') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

const { params } = useRoute();
const { getters, commit, dispatch } = useStore();
const emit = defineEmits();

const etcOption = ref({
  ETC_ALL: true,
  ETC_PACKABLE: false,
  ETC_RESERVABLE: false,
  ETC_ONLINE_PAYMENT_AVAILABLE: false,
  ETC_AUTOMATIC_WITHDRAWAL_AVAILABLE: false
});

onMounted(() => {
  matchingOption();
});

const matchingOption = () => {
  const getOptions = getters['search/getFilter'];
  const { STORE_ETC_CONDITION } = getOptions;
  STORE_ETC_CONDITION.forEach((item) => {
    etcOption.value.ETC_ALL = false;
    etcOption.value[item] = true;
  });
};

const fnSelect = (select) => {
  // if (optionList.value.find()) optionList.value.push(select);
};
const fnClose = async () => {
  let optionList = Object.keys(etcOption.value).filter((key) => etcOption.value[key] === true);
  if (optionList[0] === 'ETC_ALL') optionList = [];
  commit('search/setCheckBoxFilter', optionList);

  // 기존 리스트 정보 초기화
  commit('store/initStoreList');
  commit('store/initRecommendedStoreList');

  // await dispatch('store/fetchStoreList', {
  //   storeCategoryNo: params.storeCategoryNo
  // });
  await dispatch('store/fetchRecommendedStoreList', {
    storeCategoryNo: params.storeCategoryNo
  });
  commit('store/updateInfiniteKey');

  // if (!!params.storeCategoryNo) {
  //   replace(`/search/result`);
  // } else {
  //   replace(`/search/result/${params.storeCategoryNo}`);
  // }

  emit('close');
};
</script>

<style scoped></style>
/* *Created on 2023-09-04 *ProjectName user */
